module.exports = __webpack_public_path__ + "img/05—Applications—Speed Test 01 > Internet Download.f194e4c2.jpg";